module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00034-fs8.3ec9a8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00034-fs8.png
// module id = 187
// module chunks = 0